<template>
    <div class="orderDetail" v-loading="detailLoading">
        <el-row>
            <el-card class="order-status">
                <el-steps :active="active" align-center>
                    <el-step :title="$t('base.monitor.autoOrder')" icon="el-icon-s-order"></el-step>
                    <template v-if="order.orderStatus === 6">
                        <el-step :title="$t('order.declareCheckFailure')" status="error" icon="el-icon-s-release"></el-step>
                    </template>
                    <template v-else>
                        <el-step :title="$t('order.approve')" icon="el-icon-s-claim"></el-step>
                    </template>
                    <el-step :title="$t('order.waitReceive')" icon="el-icon-collection-tag"></el-step>
                    <el-step :title="$t('order.waitExecute')" icon="el-icon-truck"></el-step>
                    <el-step :title="$t('order.executing')" icon="el-icon-video-play"></el-step>
                    <el-step :title="$t('order.completedWaitCheck')" icon="el-icon-s-check"></el-step>
                    <el-step :title="$t('order.completed')" icon="el-icon-circle-check"></el-step>
                </el-steps>
            </el-card>
        </el-row>
        <el-row class="order-row">
            <el-card class="order-card">
                <span class="card-title"><title-icon/>{{$t('order.details')}}</span>
                <el-divider class="card-divider"></el-divider>
                <el-row>
                    <el-form label-width="100px">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('base.position.project')">
                                    <span>{{order.projectName}}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('order.declareTime')">
                                    <span>{{order.creationDateStr}}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <template v-if="order.location || order.deviceName">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item :label="$t('base.device.position')">
                                        <span>{{order.location}}</span>
                                    </el-form-item>
                                </el-col>
                                <template v-if="order.deviceName">
                                    <el-col :span="12">
                                        <el-form-item :label="$t('base.device.name')">
                                            <span>{{order.deviceName}}</span>
                                        </el-form-item>
                                    </el-col>
                                </template>
                            </el-row>
                        </template>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('order.orderType')">
                                    <template v-if="order.orderType == 1">
                                        <span>{{ $t('order.device') }}</span>
                                    </template>
                                    <template v-if="order.orderType == 2">
                                        <span>{{ $t('order.fireSafety') }}</span>
                                    </template>
                                    <template v-if="order.orderType == 3">
                                        <span>{{ $t('order.quality') }}</span>
                                    </template>
                                    <template v-if="order.orderType == 4">
                                        <span>{{ $t('order.other') }}</span>
                                    </template>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('order.level')">
                                    <span v-if="order.orderLevel==0">{{$t('order.config.ordinary')}}</span>
                                    <span v-else-if="order.orderLevel==1">{{$t('order.config.urgent')}}</span>
                                    <span v-else-if="order.orderLevel==2">{{$t('order.config.alarm')}}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('order.declareDept')">
                                    <span>{{order.submitUserDeptName}}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('order.declarePeople')">
                                    <span>{{order.submitUserName}}</span>
                                    <span style="margin-left: 20px;">{{order.submitUserPhone}}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('order.serviceDept')">
                                    <span>{{order.resDeptName}}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('order.servicePeople')">
                                    <span>{{order.handlePersonName}}</span>
                                    <span style="margin-left: 20px;">{{order.handlePersonPhone}}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item :label="$t('order.faultDesc')">
                                    <span>{{order.contentDesc}}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="order.submitPhotoList && order.submitPhotoList.length > 0">
                            <el-col :span="24">
                                <el-form-item :label="$t('order.livePhoto')">
                                    <viewer :images="order.submitPhotoList">
                                        <img class="orderImg" v-for="(src,index) in order.submitPhotoList" :src="src" :key="index">
                                    </viewer>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-row>
            </el-card>
        </el-row>
        <el-row class="order-row">
            <el-col :style="{width: '50%'}">
                <el-card class="order-card">
                    <span class="card-title"><title-icon/>{{$t('order.completeDetail')}}</span>
                    <template v-if="order.orderMaterielSonList.length>0">
                        <span style="float: right">
                            <el-button type="text" icon="el-icon-view" style="margin-top:-5px;" @click="openMaterialDetail">{{$t('order.materielDetail')}}</el-button>
                        </span>
                    </template>
                    <el-divider class="card-divider"></el-divider>
                    <el-row class="order-info">
                        <template v-if="order.orderStatus == 4 || order.orderStatus ==5">
                            <el-form label-width="100px">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item :label="$t('order.completedTime')">
                                            <span>{{order.requestDateStr}}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item :label="$t('order.submitTime')">
                                            <span>{{order.orderImp.lastUpdateDateStr}}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item :label="$t('order.completedHappening')">
                                            <span>{{order.orderImp.completeSituation}}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row v-if="order.completePhotoList && order.completePhotoList.length > 0">
                                    <el-col :span="24">
                                        <el-form-item :label="$t('order.completedPhoto')">
                                            <viewer :images="order.completePhotoList">
                                                <img class="orderImg" v-for="(src,index) in order.completePhotoList" :src="src"
                                                     :key="index">
                                            </viewer>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </template>
                        <template v-else>
                            <div class="no-data">{{$t('commons.noData')}}</div>
                        </template>
                    </el-row>
                </el-card>
            </el-col>
            <el-col :style="{width: 'calc(50% - 10px)',marginLeft:'10px'}">
                <el-card class="order-card">
                    <span class="card-title"><title-icon/>{{$t('order.dynamic')}}</span>
                    <el-divider class="card-divider"></el-divider>
                    <el-row class="order-info">
                        <el-timeline>
                            <el-timeline-item
                                    v-for="(item, index) in order.orderDynamicList"
                                    :key="index"
                                    :timestamp="item.creationDateStr">
                                {{item.userName}} {{ item.operationName }}
                            </el-timeline-item>
                        </el-timeline>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>

        <el-dialog top="5vh" :visible.sync="dialogMaterialVisible">
            <template slot="title">
                <title-icon/>{{ $t('order.materielDetail') }}
            </template>
            <el-table
                    :data="order.orderMaterielSonList"
                    style="margin-bottom: 15px;"
                    border
                    fit
                    stripe>
                <el-table-column type="index" align="center" :resizable="false" :label="$t('commons.index')" width="80">
                </el-table-column>
                <el-table-column prop="materielName" :label="$t('base.materiel.materielName')" width="160">
                </el-table-column>
                <el-table-column prop="number" :label="$t('facilityHome.number')" width="80">
                </el-table-column>
                <el-table-column prop="specifications" :label="$t('base.materiel.unit')" width="80">
                </el-table-column>
                <el-table-column prop="userName" :label="$t('order.appPerson')" width="100">
                </el-table-column>
                <el-table-column prop="deptName" :label="$t('order.appDept')" width="100">
                </el-table-column>
                <el-table-column :label="$t('order.appTime')" width="180">
                    <template slot-scope="s">
                        <span v-if="s.row.creationDate != null"> {{ s.row.creationDate | dateFormat('YYYY-MM-DD HH:mm:ss') }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>

    import {
        getOrderDetail,
    } from '@/api/business/order/tenant/order'

    export default {
        name: "OrderDetail",
        components: {},
        props: {
            orderRow: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                active: 0,
                detailLoading: false,
                order: {
                    orderId: null,
                    deviceName: '',
                    location: '',
                    submitUserDeptName: '',
                    submitUserName: '',
                    submitUserPhone: '',
                    resDeptName: '',
                    handlePersonName: '',
                    handlePersonPhone: '',
                    creationDateStr: '',
                    orderLevel: '',
                    submitPhoto: [],
                    contentDesc: '',
                    orderDynamicList: [],
                    orderMaterielSonList:[]
                },
                dialogMaterialVisible: false,
            }
        },
        created() {
            this.getOrderDetail();
        },
        methods: {
            //详情
            getOrderDetail() {
                this.detailLoading = true;
                this.order.orderId = this.orderRow.orderId;
                getOrderDetail({"orderId": this.order.orderId}).then(res => {
                    this.setActive(res.orderStatus);
                    this.order = res;
                }).finally(() => {
                    this.detailLoading = false;
                })
            },
            // 设置工单显示状态
            setActive(orderStatus) {
                // 工单已完成
                if (orderStatus === 5) {
                    this.active = 999;
                } else if (orderStatus === 6) { // 报单审核失败
                    this.active = 1;
                } else if (orderStatus === 7) { // 完成审核不通过
                    this.active = 3;
                } else{
                    this.active = orderStatus + 1;
                }
            },
            openMaterialDetail(){
                this.dialogMaterialVisible = true;
            }
        }
    }
</script>
